var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "#3EAF80",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.955 8.33342C10.8227 8.54343 10.7559 8.78809 10.7632 9.03618L11.0131 9.02881L10.7632 9.03639C10.7683 9.20317 10.8067 9.36734 10.8763 9.51906C10.9456 9.67029 11.0443 9.80609 11.1668 9.91859L15.5039 13.9946L11.1681 18.0695C11.0446 18.1799 10.9443 18.3138 10.873 18.4635C10.8013 18.6142 10.7604 18.7779 10.753 18.9447C10.7455 19.1114 10.7715 19.278 10.8295 19.4345C10.8875 19.5911 10.9763 19.7344 11.0906 19.8561C11.2048 19.9777 11.3424 20.0753 11.4951 20.1429C11.6477 20.2105 11.8123 20.2469 11.9793 20.2498C12.1463 20.2527 12.3121 20.2221 12.4669 20.1598C12.6207 20.098 12.7606 20.0062 12.8786 19.8898L18.1827 14.9054C18.1827 14.9053 18.1828 14.9053 18.1828 14.9053C18.3072 14.7885 18.4063 14.6475 18.4741 14.4908C18.5419 14.3342 18.5769 14.1653 18.5769 13.9946C18.5769 13.8239 18.5419 13.6551 18.4741 13.4985C18.4063 13.3419 18.3072 13.2007 18.1827 13.0838L12.8773 8.09808C12.6986 7.92658 12.473 7.81201 12.2291 7.76899C11.9846 7.72586 11.7329 7.75661 11.506 7.85712C11.2791 7.95763 11.0873 8.12338 10.955 8.33342Z",
    fill: "#19AB87",
    stroke: "#19AB87",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.3c8cfc8565344b2bc74191d67d449f82.svg";
export { ForwardRef as ReactComponent };